import React, { useState, useEffect } from 'react'
import { get, defaultErrorCallback } from '@chilipiper/service/src/api'
import { styled } from '@chilipiper/design-system'

interface CurrentWorkspaceResponse {
  domain: string
  logo: string
}

interface Props {
  isMeetingWith?: boolean
  size?: number
}

const StyledImage = styled.img<{ maxHeight: string }>`
  width: auto;
  max-width: 250px;
  max-height: ${props => props.maxHeight};
`

export const Logo = ({ size = 128, isMeetingWith }: Props) => {
  const [domain, setDomain] = useState('')
  const [clearbitUnusable, setClearbitUnusable] = useState(false)
  const [logo, setLogo] = useState<string | undefined>()
  const meetingWith = isMeetingWith ? 'fabe-company-logo-meetwith' : ''
  const maxHeight = isMeetingWith ? '5rem' : '3rem'

  useEffect(() => {
    get('company-logo/current-workspace')
      .json<CurrentWorkspaceResponse>()
      .then(result => {
        setLogo(result.logo)
        setDomain(result.domain)
      })
      .catch(defaultErrorCallback)
  }, [])

  const renderLogo = () => {
    if (logo) {
      return <StyledImage maxHeight={maxHeight} src={logo} alt={`Logo ${domain}`} />
    } else if (domain && !clearbitUnusable) {
      return (
        <StyledImage
          maxHeight={maxHeight}
          src={`//logo.clearbit.com/${domain}?size=${size}`}
          onError={() => setClearbitUnusable(true)}
          alt={`Logo ${domain}`}
          crossOrigin={inIframe() ? 'anonymous' : undefined}
        />
      )
    }
    return null
  }

  return (
    <div className={`fabe-company-logo ${meetingWith}`} data-test-id='Logo-image'>
      {renderLogo()}
    </div>
  )
}

export const inIframe = () => {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}
